import { words, image, block } from '../../../assets/js/modules/_animations.js';

image( '.person-header .person-header__image figure' );
words( '.person-header .wp-block-post-title', { delay: 400 } );
block( '.person-header .breadcrumb', { delay: 1200 } );
block( '.person-header .person-title', { delay: 1200 } );
block( '.person-header .person-contact', { delay: 1200 } );
block( '.person-header .person-header__terms', { delay: 1200 } );
